/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ContactLoginMethod {
    Pin = 1,
    Badge = 2,
}
